import { Map, Record } from "immutable"

import { changeInsurance } from "../api/manageApi"
import { mapperCreatedBookingChange } from "../mapper/services/mapperManageBookingChange"
import { ERROR, INIT, LOADING, SUCCESS } from "common/consts/phase"
import { currencySelector } from "common/services/currencies/selectors"
import { openModal } from "../index"
import { bookedAtSelector } from "common/services/branding/selectors"
import { MODALS } from "mmb/consts/booking"
import type { PassengerId } from "mmb/types/primitiveTypes"
import type { ServiceForPaymentType } from "../types"
import {
  DESELECT,
  RESET,
  SELECT,
  SUBMIT,
  SUBMIT_FAILURE,
  SUBMIT_REQUEST,
  SUBMIT_SUCCESS,
} from "mmb/scenes/AccountBooking/components/Booking/services/bookingInsurance/consts"

const InitialState = new Record({
  passengers: new Map(),
  phase: INIT,
  error: null,
})

type Action = {
  type: string,
  pid?: PassengerId,
  insurance: number,
  error: string,
}

export default function insuranceReducer(state: InitialState = new InitialState(), raw: Action) {
  if (!(state instanceof InitialState)) return new InitialState(state)

  const action = raw
  if (action.pid) {
    // prevents key confusion - "1234" vs 1234
    action.pid = Number(action.pid)
  }

  switch (action.type) {
    case RESET:
      return new InitialState()

    case SELECT:
      return state.setIn(["passengers", action.pid], action.insurance)

    case DESELECT:
      return state.deleteIn(["passengers", action.pid])

    // submit
    // ---

    case SUBMIT_REQUEST:
      return state.set("phase", LOADING)

    case SUBMIT_SUCCESS:
      return state.set("phase", SUCCESS)

    case SUBMIT_FAILURE:
      return state.set("phase", ERROR).set("error", action.error)

    default:
      return state
  }
}

export const reset = () => ({
  type: RESET,
})

export const selectInsurance = (pid: PassengerId, insurance: number) => ({
  type: SELECT,
  pid,
  insurance,
})

export const deselectInsurance = (pid: PassengerId) => ({
  type: DESELECT,
  pid,
})

export const submit = (serviceForPayment: ServiceForPaymentType) => async (
  dispatch: Dispatch<*>,
  getState: () => any,
) => {
  const state = getState()

  const { payload } = serviceForPayment
  const promise = changeInsurance({
    ...payload,
    currency: currencySelector(state),
    booked_at: bookedAtSelector(state),
  })

  const ok = await dispatch({
    type: SUBMIT,
    action: SUBMIT,
    payload,
    promise,
    bid: serviceForPayment.bid,
    _track: { payload },
  })

  if (ok) {
    if (serviceForPayment.price <= 0) {
      dispatch(openModal(MODALS.CREDIT_PAYMENT_THANK_YOU))

      return ok
    }

    return promise.then(res => mapperCreatedBookingChange(res))
  }

  return ok
}
